import { GlobalResponseObject } from "@schemax-whatsapp/shared-models/common";
import { SchemaxDepartmentModel } from "./schemax-department.model";

export class SchemaxDepartmentResponse extends GlobalResponseObject {
    data?: SchemaxDepartmentModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SchemaxDepartmentModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}